import React from "react";
import backgroundImage from "../../assets/loginimage.jpg";
import FormLogin from "../../components/Forms/FormLogin";
import MetaTitle from "../../components/MetaTitle";
import { ImageLogin, LoginDiv } from "./styles";

export default function Login() {
  return (
    <>
      <MetaTitle title="Entrar" />
      <LoginDiv>
        <ImageLogin src={backgroundImage} />
        <FormLogin />
      </LoginDiv>
    </>
  );
}
